import React, { FC, ReactNode } from 'react';
import Notification from '../../components/Notification';

type NotificationProviderProps = {
  children: ReactNode;
};

const NotificationProvider: FC<NotificationProviderProps> = ({ children }) => {
  return (
    <>
      <Notification />
      {children}
    </>
  );
};

export default NotificationProvider;
